import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import withStyles from '@mui/styles/withStyles';
import AchievementsContext from "../../contexts/achievements-context";

const styles = (theme) => ({
  wrapper: {
    paddingTop: 80,
  },
  lection: {
    backgroundColor: "#57ABE8",
    height: 250,
    color: "#fff",
    borderRadius: "0 0 0 60px",
  },
  secondLection: {
    zIndex: -1,
    backgroundColor: "#FFAB9D",
    height: 150,
    color: "#fff",
    width: "100%",
    borderRadius: "0 0 0 60px",
  },
  firstUnits: {
    marginTop: 120,
    marginLeft: 40,
  },
  secondUnits: {
    marginLeft: 40,
  },
  value: {
    fontSize: 57,
    fontWeight: "bold",
  },
  unit: {
    marginLeft: 10,
    fontSize: 46,
    fontWeight: 200,
    color: "rgba(255, 255, 255, 0.5)",
  },
  learntime: {
    marginLeft: 40,
    fontSize: 14,
    color: "rgba(255, 255, 255, 0.5)",
  },
});

const UnitBox = ({ classes }) => {
  const { finishedSections, finishedMinutes } = useContext(AchievementsContext);

  return (
    <div className={classes.wrapper}>
      <div style={{ backgroundColor: "#FFAB9D" }}>
        <Box className={classes.lection} display="flex" flexDirection="column">
          <Box
            display="flex"
            className={classes.firstUnits}
            alignItems="center"
          >
            <Typography
              align="left"
              variant="body1"
              component="p"
              color="inherit"
              className={classes.value}
            >
              {finishedSections}
            </Typography>
            <Typography
              align="left"
              variant="body1"
              component="p"
              color="inherit"
              className={classes.unit}
            >
              Lektionen
            </Typography>
          </Box>
          <Box display="flex" className={classes.sub} alignItems="center">
            <Typography
              align="left"
              variant="body1"
              component="p"
              color="inherit"
              className={classes.learntime}
            >
              Abgeschlossen
            </Typography>
          </Box>
        </Box>
      </div>
      <Box
        className={classes.secondLection}
        display="flex"
        flexDirection="column"
      >
        <Box display="flex" className={classes.secondUnits} alignItems="center">
          <Typography
            align="left"
            variant="body1"
            component="p"
            color="inherit"
            className={classes.value}
          >
            {finishedMinutes}
          </Typography>
          <Typography
            align="left"
            variant="body1"
            component="p"
            color="inherit"
            className={classes.unit}
          >
            min
          </Typography>
        </Box>
        <Box display="flex" className={classes.sub} alignItems="center">
          <Typography
            align="left"
            variant="body1"
            component="p"
            color="inherit"
            className={classes.learntime}
          >
            Lernzeit
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default withStyles(styles)(UnitBox);
